import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { KiMandantEinstellungen } from '../models/ki.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KiEinstellungenService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiBaseUrl}/api/v1/ki/einstellungen`;

  laden(): Observable<KiMandantEinstellungen> {
    return this.http.get<KiMandantEinstellungen>(this.apiUrl);
  }

  speichern(einstellungen: KiMandantEinstellungen): Observable<KiMandantEinstellungen> {
    return this.http.put<KiMandantEinstellungen>(this.apiUrl, einstellungen);
  }
}
